module.exports = __webpack_public_path__ + "img/d5.32ef1125.png";